import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntDropdownItemDirective} from "./int-dropdown-item.directive";
import {IntDropdownListComponent} from "./int-dropdown-list.component";
import {IntInsertAfterViewInitModule} from "../../../directives";
import {IntDropdownAreaModule} from "../int-dropdown-area";


@NgModule({
  imports: [
    CommonModule,
    IntInsertAfterViewInitModule,
    IntDropdownAreaModule
  ],
  declarations: [
    IntDropdownItemDirective,
    IntDropdownListComponent,
  ],
  exports: [
    IntDropdownItemDirective,
    IntDropdownListComponent
  ]
})
export class IntDropdownListModule {}
